import { ssoAPIHelper } from "services/SSOAPIHelper";
import { inMiniProgram } from "utils/WeChatUtil"

export function openLoginPage(
    {
        locale,
        redirectTo,
        isEventRegister = false,
        eventRequireCompleteRegistration=false,
        enableOtp = false,
        email = null,
        mobile = null,
        ticketRegisterAsMember = false,
        useRedirect = false,
    }
) {
    const isInMiniProgram = inMiniProgram()
    const loginUrl = ssoAPIHelper.getLoginWebUri(
        {
            locale,
            redirectTo,
            isEventRegister,
            enableOtp,
            email,
            mobile,
            ticketRegisterAsMember,
            eventRequireCompleteRegistration,
        }
    );
    if (isInMiniProgram) {
        const weChatLoginUrl = `/pages/login/login?redirect_url=${encodeURIComponent(loginUrl)}` + "&lang=" + encodeURIComponent(locale)
        if (useRedirect) {
            window.wx.miniProgram.redirectTo({ url: weChatLoginUrl })
            return
        }
        window.wx.miniProgram.navigateTo({ url: weChatLoginUrl })
        return
    }
    if (useRedirect) {
        window.location.replace(loginUrl)
        return
    }
    window.location.href = loginUrl
}